import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22180 21984"
    {...props}
  >
    <path
      d="M11107 7424c-4647 34-4691 6933-56 7035 4680 4 4725-6972 56-7035zm8108 10602c169-2385-1227-5258-3989-4938-365 604-1907 1352-1405 2052 1875 2212 1663 5779-1556 6505-3122 815-5894-834-8435-2402 63-73 126-147 189-221 2464 55 4969-1073 4882-3831-139-680-968-994-1368-1521-227-251-384-243-650-84-7588 5036-8621-6122-3943-9629-102 2449 1064 4884 3847 4818 674-148 1016-952 1543-1346 256-225 248-383 81-644-5057-7450 6028-8494 9831-3930-2510-16-5024 1004-4938 3835 158 574 1293 1762 1938 1621 7642-5033 8698 5995 3973 9715z"
      style={{
        fill: "#000",
        stroke: "#fefefe",
        strokeWidth: 245.821,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
